import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { style } from "./style";
import Profile from "../../../../assets/images/user1.png";
import { ReactComponent as Calender } from "../../../../assets/ViewLeave-images/Vector (1).svg";
import { ReactComponent as Hastag } from "../../../../assets/ViewLeave-images/ph_hash-bold.svg";
import { ReactComponent as Info } from "../../../../assets/ViewLeave-images/material-symbols_info-outline.svg";
import { formatDate } from "../../../../utils/DateFormat";

const ViewTravelAllowancesPage = ({ item }) => {

  return (
    <>
      <Grid container sx={{ display: "flex", p: "25px", justifyContent: "space-between" }}>
        <Grid item xs={12} lg={7.4} sx={style.gridbioBox}>
          <Box sx={style.upperContainer}>
            <Box sx={style.profileBox}>
              <Box>
                <Avatar alt="profile" src={item?.image} sx={style.avatar} />
              </Box>
              <Box>
                <Typography variant="h4" sx={style.employeeName}>{item?.fullName}</Typography>
                <Typography variant="p" sx={style.textPrimary}>{item?.employeeDetails[0]?.personalInfo?.firstName} {item?.employeeDetails[0]?.personalInfo?.surName}</Typography>
                <Typography variant="body1" sx={style.employeeId}>{`Employee Email: ${item?.employeeDetails[0]?.personalInfo?.email}`}</Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={style.infooBox}>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Calender />
                <Typography variant="body1" sx={style.bioIconText}>
                  Start Date
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {formatDate(item?.start)}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Calender />
                <Typography variant="body1" sx={style.bioIconText}>
                  End Date
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {formatDate(item?.end)}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Hastag />
                <Typography variant="body1" sx={style.bioIconText}>
                  Kilometer
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.kilometer}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Info />
                <Typography variant="body1" sx={style.bioIconText}>
                  Status
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.status}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid >
    </>
  )
}
export default ViewTravelAllowancesPage;
